import { useNavigate } from 'react-router-dom';

export default function Footer() {
  const navigate = useNavigate();

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleExploreClick = (item: string) => {
    if (item === 'Ski Trikke') {
      navigate('/ski-trikke');
      return;
    }
    scrollToSection(item.toLowerCase().replace(' ', '-'));
  };

  const handleNewsletterSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    const formBody = new URLSearchParams();
    
    formData.forEach((value, key) => {
      formBody.append(key, value.toString());
    });

    try {
      await fetch('https://readdy.ai/api/form/d6iq2codenotc3br4820', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });
      form.reset();
    } catch (error) {
      console.error('Form submission error:', error);
    }
  };

  return (
    <footer className="w-full py-16 md:py-24 px-6 md:px-12 lg:px-24" style={{ backgroundColor: '#1B3A2F' }}>
      <div className="max-w-7xl mx-auto">
        {/* Upper Section - Responsive Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10 md:gap-16 mb-14 md:mb-20">
          {/* Column 1 - Brand */}
          <div className="col-span-2 md:col-span-1">
            <img
              src="https://www.dropbox.com/scl/fi/f07ifs1yd05cfcl5cs6mt/234187158.png?rlkey=vl3eoprhczi5ajtexxf2qds9b&st=fmwe88ls&raw=1"
              alt="Vonnes Alpine Life"
              className="h-10 md:h-12 w-auto mb-6 object-contain"
            />
            <div className="space-y-2 text-sm font-light" style={{ color: '#C5C5C5' }}>
              <p>Châtel, French Alps</p>
              <p>info@vonnesalpinelife.eu</p>
              <p>+33 4 50 73 22 44</p>
            </div>
          </div>

          {/* Column 2 - Newsletter */}
          <div className="col-span-2 md:col-span-1">
            <h4 className="text-xs tracking-widest mb-6" style={{ color: '#C5C5C5', letterSpacing: '2px' }}>
              STAY CONNECTED
            </h4>
            <form id="newsletter-form" data-readdy-form onSubmit={handleNewsletterSubmit} className="mb-4">
              <div className="flex items-center border-b border-gray-500 pb-2">
                <input
                  type="email"
                  name="email"
                  placeholder="Your email"
                  required
                  className="flex-1 bg-transparent text-white text-sm focus:outline-none placeholder-gray-400"
                />
                <button type="submit" className="cursor-pointer">
                  <i className="ri-arrow-right-line text-white text-lg"></i>
                </button>
              </div>
            </form>
            <a href="#" className="text-xs font-light hover:underline cursor-pointer" style={{ color: '#D4AF37' }}>
              Privacy Policy
            </a>
          </div>

          {/* Column 3 - Quick Links */}
          <div>
            <h4 className="text-xs tracking-widest mb-6" style={{ color: '#C5C5C5', letterSpacing: '2px' }}>
              EXPLORE
            </h4>
            <div className="space-y-3">
              {['Chalet', 'Ski Trikke', 'About', 'Gallery', 'Contact'].map((item) => (
                <button
                  key={item}
                  onClick={() => handleExploreClick(item)}
                  className="block text-white text-base font-light hover:opacity-70 transition-opacity cursor-pointer"
                >
                  {item}
                </button>
              ))}
            </div>
          </div>

          {/* Column 4 - Social */}
          <div>
            <h4 className="text-xs tracking-widest mb-6" style={{ color: '#C5C5C5', letterSpacing: '2px' }}>
              FOLLOW US
            </h4>
            <div className="space-y-3">
              <a href="#" className="block text-white text-base font-light hover:opacity-70 transition-opacity cursor-pointer">
                Instagram
              </a>
              <a href="#" className="block text-white text-base font-light hover:opacity-70 transition-opacity cursor-pointer">
                Facebook
              </a>
              <a href="#" className="block text-white text-base font-light hover:opacity-70 transition-opacity cursor-pointer">
                LinkedIn
              </a>
            </div>
          </div>
        </div>

        {/* Lower Section - Large Brand Typography */}
        <div className="relative overflow-hidden py-8 md:py-12">
          <h2
            className="text-5xl sm:text-7xl md:text-9xl font-bold text-center tracking-wider"
            style={{ color: '#E8DCC8', fontFamily: '"Playfair Display", Georgia, serif', fontStyle: 'italic' }}
          >
            VONNES <span style={{ fontFamily: '"Playfair Display", Georgia, serif', fontStyle: 'italic' }}>VACANCES</span>
          </h2>
        </div>

        {/* Copyright */}
        <div className="text-center pt-8 border-t" style={{ borderColor: '#2D5A4A' }}>
          <p className="text-sm font-light" style={{ color: '#C5C5C5' }}>
            © 2024 Vonnes Alpine Life. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}